<ngx-extended-pdf-viewer
  [src]="dialogConfig.data"
  [height]="'95%'"
  [textLayer]="true"
  [showHandToolButton]="true"
  />
  
  <!--
    [useBrowserLocale]="true"
-->
